import styled from 'styled-components';
import { getToken } from '@optimus-web/common';

const menuWidth = 360;

export const MenuContainerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 32px 0;
    overflow-y: auto;
    width: ${menuWidth}px;
    background: ${getToken('backgroundStaticRaised')};
    border-right: ${getToken('borderWidth150')}px solid ${getToken('borderStaticSecondary')};
`;
